import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";
import { Reveal } from "./Reveal";

const API = process.env.REACT_APP_BACKEND_URL;

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!API) return toast.error("Sign-up is unavailable right now");
    setBusy(true);
    try {
      const res = await axios.post(`${API}/api/subscribe`, { email });
      toast.success(res.data?.message ?? "You're on the list");
      setEmail("");
    } catch (err) {
      toast.error(err.response?.data?.detail ?? "Something went wrong, try again");
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="relative overflow-hidden py-24 lg:py-36" data-testid="newsletter-section">
      <div className="spotlight pointer-events-none absolute left-1/2 top-1/2 h-[60vh] w-[60vh] -translate-x-1/2 -translate-y-1/2 rounded-full opacity-70" />
      <Reveal className="relative mx-auto max-w-3xl px-5 text-center">
        <span className="font-mono text-xs uppercase tracking-[0.25em] text-cyanx">The drop list</span>
        <h2 className="mt-5 font-display text-4xl font-black uppercase leading-[0.9] sm:text-6xl">First dibs on<br /><span className="text-volt">new slabs.</span></h2>
        <p className="mx-auto mt-6 max-w-md text-base text-slate-300">Get an email when fresh graded cards go live — before they hit the feed.</p>
        <form onSubmit={submit} className="mx-auto mt-10 flex max-w-lg flex-col gap-3 rounded-[28px] border border-white/15 bg-white/[0.03] p-2 backdrop-blur sm:flex-row sm:rounded-full" data-testid="newsletter-form">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@collector.com" className="flex-1 bg-transparent px-5 py-3 text-base text-white placeholder:text-slate-500 focus:outline-none" data-testid="newsletter-email-input" />
          <button type="submit" disabled={busy} className="btn-primary group justify-center" data-testid="newsletter-submit-btn">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <>Notify me <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" /></>}
          </button>
        </form>
      </Reveal>
    </section>
  );
};
